import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

const Store = lazy(() => import('@pages/store'));
const ProductList = lazy(() => import('@pages/store/product/ProductList'));
const ProductDetail = lazy(() => import('@pages/store/product/ProductDetail'));

export const storeRoutes: TypedRouteObject = {
	path: ROOTS.STORE,
	element: withSuspense(Store),
	handle: {
		title: '스토어 상품 관리',
		subTitle: '락앤런 트레일러닝 스토어 상품 관리',
		permission: 'STORES' // 스토어 관리 권한 필요
	},
	children: [
		{
			index: true,
			element: <Navigate to="list" replace />
		},
		// 상품 관리
		{
			path: paths.store.list.path,
			element: withSuspense(ProductList),
			handle: {
				title: '락앤런 스토어 상품 관리',
				subTitle: '락앤런 스토어 상품 등록 및 관리',
			}
		},
		{
			path: paths.store.detail.path,
			element: withSuspense(ProductDetail),
			handle: {
				isGoBack: true,
				title: '락앤런 스토어 상품 관리',
				subTitle: '스토어 > 상품 관리 > 상품 상세 정보',
			}
		}
	]
}
